import CharacterContainer from 'components/Character/CharacterContainer'

export default {
  Container: CharacterContainer,
}
